<template>
<div class="wrapper">
  <div class="top-box">
    <div class="top-video">
      <video class="pc" src="@/assets/top-pc.mp4" autoplay muted loop></video>
      <video class="sp" src="@/assets/top-sp.mp4" autoplay  muted loop playsinline></video>
    </div>
    <div class="top-message-box">
      <h1 class="top-message">世界一安全に、<br class="pc-br">大型輸送をする会社</h1>
      <h2 class="top-message-caption">Moving BOX with SAFETY</h2>
    </div>
  </div>
  <div class="table-container">
    <div class="table-title">News</div>
    <div class="table-scroll">
      <div class="table">
          <div class="row" v-for="(item, index) in items" :key=index>
            <div class="row-heading">
              <div class="date">{{ item.date }}</div>
              <div class="department">{{ item.department }}</div>
            </div>
            <div class="col-lg-10 col-m-10 col-sm-10 col-12 content" v-if="item.url">
              <a v-bind:href="item.url" target="_blank">{{ item.content }}</a>
            </div>
            <div class="col-lg-10 col-m-10 col-sm-10 col-12 content" v-else>
              <a >{{ item.content }}</a>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="container banner">
    <div class="row banner-row">
      <router-link class="col-md-4 col-lg-4 col-xs-12 bus-banner" to="/bus">
        <div class="box1" to="/bus">
          <p>BUS</p>
        </div>
        <div class="box2">
          <p>貸切バスのご案内</p>
        </div>
      </router-link>
      <router-link class="col-md-4 col-lg-4 col-xs-12 cargo-banner" to="/freight">
        <div class="box1">
          <p>FREIGHT</p>
        </div>
        <div class="box2">
          <p>貨物のご案内</p>
        </div>
      </router-link>
    </div>
    <div class="row banner-row">
      <router-link class="col-md-4 col-lg-4 col-xs-12 const-banner" to="/construction">
        <div class="box1 box1-const">
          <p>CONSTRUCTION</p>
        </div>
        <div class="box2">
          <p>工事のご案内</p>
        </div>
      </router-link>
      <router-link class="col-md-4 col-lg-4 col-xs-12 safety-banner" to="/safety">
        <div class="box1 box1-saftey">
          <p>SAFETY</p>
        </div>
        <div class="box2">
          <p>安全への取り組み</p>
        </div>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      items: []
    }
  },
  created () {
    axios
      .get('https://script.google.com/macros/s/AKfycbzLbrMLbgO1esSEvc0ckfTlYMODegABBSXe0qhHOE1iwd-Ti6u2/exec', { crossDomain: true })
      .then(response => (this.items = response.data))
  }
}
</script>

<style scoped>
.wrapper {
  overflow: hidden;
}
.top-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
video {
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pc {
  display: block !important;
}
.sp {
  display: none !important;
}
@media only screen and (max-width:480px) {
  .pc {
    display: none !important;
  }
  .sp {
    display: block !important;
  }
}
@media only screen and (min-width:540px) and (orientation:portrait) {
  .pc {
    display: none !important;
  }
  .sp {
    display: block !important;
  }
}
.top-message-box {
  position: absolute;
  top: 37%;
  bottom: 0;
  right: 0;
  left: 0;
}
.top-message {
  font-size: 36px;
  text-align: center;
  font-weight: bold;
  color: #FFFFFF;
  width: 100%;
}
.top-message-caption {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  color: #FFFFFF;
  width: 100%;
}
.mynavi {
  margin-top: 45px;
}
.banner {
  padding-right: 50px;
  padding-left: 50px;
}
.banner-row {
  margin-bottom: 21px;
  margin-top: 21px;
  display: flex;
  justify-content: space-around;
}
.bus-banner {
  background-image: url("../assets/bus-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  background-position-x: 69%;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.cargo-banner {
  background-image: url("../assets/cargo-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.const-banner {
  background-image: url("../assets/construction-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.safety-banner {
  background-image: url("../assets/safety.jpg");
  background-repeat: no-repeat;
  background-size:  cover;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.box1 {
  padding: 0.5em 1em;
  margin: 15px 13px;
  font-weight: bold;
  border: solid 3px #FFFFFF;
  min-height: 124px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.box1 p {
  font-size: 38px;
  color: #FFFFFF;
  margin: 0;
  padding: 0;
}
.box1-const p {
  font-size: 25px!important;
}
.box2 {
  box-shadow: 2px 2px 4px gray;
  position: absolute;
  padding: 5px 14px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: -23px;
  min-width: 170px;
  text-align: center;
}
.box2 p {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.table-container {
  padding: 50px;
  background: #fff7fc;
}
.table-title {
  color: #6F6B6B;
  padding-bottom: 22px;
}
.table {
  background: #FFFFFF;
}
.table-scroll {
  height: 250px;
  overflow-y: auto;
  background: #FFFFFF;
}
.table-scroll::-webkit-scrollbar {
  width: 10px;
}
.table-scroll::-webkit-scrollbar-thumb {
  background-color: rgb(150,150,150);
  border-radius: 5px;
  box-shadow: inset 3px 3px 3px rgba(255,255,255,0.2);
}
.table-scroll::-webkit-scrollbar-track {
background-color: rgb(220,220,220);
border-radius: 5px;
box-shadow: inset 3px -3px 5px rgba(0,0,0,0.2);
}
.table {
  font-size: 13px;
  width: 98%;
  padding-left: 25px;
}
.table .row {
  border-top: 1px solid #dee2e6;
  padding: .75rem;
  vertical-align: top;
}
.row-heading {
  min-width: 128px;
  display: flex;
  justify-content: space-between;
}
.table .date {
  font-weight: bold;
}
.table .department {
  min-width: 52px;
}
.table .content {
  padding-left: 0px;
}
@media screen and (min-width:800px) {
  .pc-br {
    display: none;
  }
  .top-message {
    font-size: 50px;
  }
}
@media screen and (max-width:600px) {
  .box2 p {
    font-size: 16px;
  }
  .table-container {
    padding: 25px 15px;
  }
  .table-title {
    padding-left: 5px;
  }
  .table .content {
    padding-top: .75rem;
  }
  .table {
    font-size: 13px;
    width: 90%;
    padding-left: 25px;
  }
  .table-scroll {
    height: 350px;
  }
  .table-scroll::-webkit-scrollbar {
    width: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue